import { isHttpError } from "@/shared/api/errors"
import {
	completeEiTestApiV1AuthEiTestCompletePost,
	getEiLeaderboardApiV1AuthEiLeaderboardGet,
	getEiResultsApiV1AuthEiResultsGet,
	getEiTestApiV1AuthEiTestGet,
	getUserEiApiV1AuthUserUserIdEiGet,
	patchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatch,
	saveEiAnswersApiV1AuthEiTestAnswersPut,
	startEiTestApiV1AuthEiTestStartPost,
} from "@/shared/api/generated-backend"
import { deadlineFetch } from "@/shared/api/http"
import type {
	EiLeaderboard,
	EiProfile,
	EiResult,
	EiSaveAnswers,
	EiSaveAnswersResult,
	EiSession,
} from "../model/types"

const COMPLETE_TIMEOUT_MS = 15_000

async function orNull<T>(request: Promise<T>): Promise<T | null> {
	try {
		return await request
	} catch (error) {
		if (isHttpError(error) && error.status === 404) return null
		throw error
	}
}

export async function getEiProfile(userId: number): Promise<EiProfile> {
	return getUserEiApiV1AuthUserUserIdEiGet({
		path: { user_id: userId },
	})
}

export async function setEiVisibility(
	userId: number,
	visible: boolean,
): Promise<void> {
	await patchEiVisibilityApiV1AuthUserUserIdEiVisibilityPatch({
		path: { user_id: userId },
		body: { visible_to_others: visible },
	})
}

export function getEiSession(): Promise<EiSession | null> {
	return orNull(getEiTestApiV1AuthEiTestGet())
}

export async function startEiTest(restart: boolean): Promise<EiSession> {
	return startEiTestApiV1AuthEiTestStartPost({
		body: { restart },
	})
}

export async function saveEiAnswers(
	body: EiSaveAnswers,
): Promise<EiSaveAnswersResult> {
	return saveEiAnswersApiV1AuthEiTestAnswersPut({
		body,
	})
}

export async function completeEiTest(): Promise<EiResult> {
	return completeEiTestApiV1AuthEiTestCompletePost({
		fetch: deadlineFetch(COMPLETE_TIMEOUT_MS),
	})
}

export function getEiResult(): Promise<EiResult | null> {
	return orNull(getEiResultsApiV1AuthEiResultsGet())
}

export async function getEiLeaderboard(
	highlightUserId?: number,
): Promise<EiLeaderboard> {
	const query: { highlight_user_id?: number } = {}
	if (highlightUserId !== undefined) query.highlight_user_id = highlightUserId
	return getEiLeaderboardApiV1AuthEiLeaderboardGet({ query })
}
